/**
 * Coordinators can't see the tasks tab
 * @param systemRole
 * @return {boolean}
 */
export const batchTasksTabIsEnabled = systemRole =>
  systemRole !== "COORDINATOR";
